import React, { useState, useEffect } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import { Divider, Grid, Typography, Button } from "@material-ui/core";
import { Link, withRouter } from "react-router-dom";
import IconButton from "@material-ui/core/IconButton";
import { Tooltip } from "@material-ui/core";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import CustomPagination from "../../cm_shared/CMCustomPagination";
import RefreshIcon from "@material-ui/icons/Refresh";
const customStyles = {
  table: {
    style: {
      border: "solid 1px rgba(0,0,0,.2)",
      borderRadius: "10px",
    },
  },
  rows: {
    style: {
      minHeight: "72px",
      cursor: "pointer",
      fontSize: 16,
    },
  },
  headCells: {
    style: {
      paddingLeft: "8px",
      paddingRight: "8px",
      backgroundColor: "#b0ff45",
      justifyContent: "center",
    },
  },
  cells: {
    style: {
      paddingLeft: "8px",
      paddingRight: "8px",
      fontWeight: "bold",
      justifyContent: "center",
    },
  },
};

const DownloadArchiveList = () => {
  const [downloaingData, setDownloaingData] = useState(null);
  const [loading, setLoading] = useState([]);
  const [page, setPage] = useState(0);
  const [total, setTotal] = useState(0);
  const rowsPerPageSessionBased = [10, 20, 50, 100];
  const [eventsPerPage, setEventsPerPage] = useState(10);
  const [latestDownload, setLatestDownload] = useState(null);

  const initialColumns = [
    {
      name: "User Id",
      selector: "user_id",
      sortable: true,
    },
    {
      name: "Status",
      selector: "status",
      sortable: true,
    },
    {
      name: "Initiated From",
      selector: "initiated_from",
      sortable: true,
      cell: (row) => {
        return <span>{row.initiated_from}</span>;
      },
    },
    {
      name: "Page Type",
      selector: "page_type",
      sortable: true,
      cell: (row) => {
        return <span>{row.page_type}</span>;
      },
    },
    {
      name: "Folder Name",
      selector: "bulk_download_folder_name",
      sortable: true,
      cell: (row) => {
        return <span>{row.bulk_download_folder_name}</span>;
      },
    },
    {
      name: "Started At ",
      selector: "created_at",
      sortable: true,
      cell: (row) => {
        return <span>{row.created_at}</span>;
      },
    },
    {
      name: "Actions",
      selector: "progress",
      sortable: true,
      reorder: true,
      cell: (row) => {
        return (
          <div style={{ display: "flex", justifyContent: "space-around" }}>
            <Tooltip placement="top" title={<h6>Download</h6>}>
              <IconButton
                disabled={row.status !== 'COMPLETED'}
                aria-label="download"
                onClick={() => handleDownload(row.download_url)}
              >
                <CloudDownloadIcon />
              </IconButton>
            </Tooltip>
          </div>
        );
      },
    },
  ];

  const handleDownload = async (filePath) => {
    const fileToDownload = await axios.post("/generate-presigned-url", {
      s3_location: filePath,
    });
    window.open(fileToDownload.data.presigned_url);
  };

  const fetchDownlaodingData = async () => {
    try {
      setLoading(true);
      const response = await axios.post(
        `/cm/download-archive-list?page_size_record=${eventsPerPage}&page_number_record=${
          page + 1
        }`,
        {
          page_number_record: page + 1,
          page_size_record: eventsPerPage,
        }
      );
      const query = new URLSearchParams(window.location.search);
      setLatestDownload(query.get("latestDownload"));
      if (query.get("latestDownload")) {
        const latestData = response.data.data.filter(
          (item) =>
            item.bulk_download_folder_name ===
            query.get("latestDownload")
        );
        setDownloaingData(latestData);
      } else setDownloaingData(response.data.data);
      setTotal(response.data.total_records);
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoading(false);
    }
  };

  const clearLatestList = () => {
    const path = window.location.pathname;
    window.history.replaceState(null, '', path);
    fetchDownlaodingData();
  };

  const handleChangeRowsPerPage = (event) => {
    setEventsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    fetchDownlaodingData();
  }, [eventsPerPage, page]);

  return (
    <div
      style={{
        padding: "1rem",
        position: "relative",
        background: "white",
        margin: "30px",
        borderRadius: "10px",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          backgroundColor: "white",
          padding: "5px",
          width: "100%",
        }}
      >
        <Typography variant="h5">
          <Link to="/welcome">Welcome </Link> {">"} Download Archive List
        </Typography>
        <div>
        {latestDownload && (
          <Button
            onClick={clearLatestList}
            variant="outlined"
            color="secondary"
          >
            Clear
          </Button>
        )} 
        <Tooltip placement="top" title={<h6>Refresh List</h6>}>
          <IconButton onClick={fetchDownlaodingData}>
            <RefreshIcon />
          </IconButton>
        </Tooltip>
        </div>
      </div>
      <Divider />
      <Grid
        container
        spacing={3}
        style={{
          marginTop: "5px",
          marginBottom: "5px",
          justifyContent: "space-between",
        }}
      >
        <Grid item>
          <CustomPagination
            total={total}
            rowsPerPageOptions={rowsPerPageSessionBased}
            eventsPerPage={eventsPerPage}
            page={page}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            onPageChange={(event, newPage) => setPage(newPage)}
          ></CustomPagination>
        </Grid>
      </Grid>
      <div style={{ overflowX: "auto" }}>
        {loading === false && initialColumns.length > 0 ? (
          <DataTable
            columns={initialColumns}
            data={downloaingData}
            customStyles={customStyles}
          ></DataTable>
        ) : null}
      </div>
    </div>
  );
};
export default withRouter(DownloadArchiveList);
